import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class ShadowWolf extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'shadowWolf')
    
    this.maxHealth = 45
    this.health = 45
    this.damage = PLAYER_DAMAGE.LIGHT
    this.moveSpeed = 1.6
    this.attackRange = 1.2
    this.attackCooldown = 0.6
    this.detectionRange = 25
    
    this.leapCooldown = 0
    this.leapSpeed = 3
    this.leapDuration = 0.35
    this.leapTimer = 0
    this.isLeaping = false
    this.leapVelocity = { x: 0, y: 0 }
  }
  
  update(delta) {
    super.update(delta)
    
    this.leapCooldown -= delta
    if (this.isLeaping) {
      this.leapTimer -= delta
      if (this.leapTimer <= 0) {
        this.isLeaping = false
        this.leapVelocity = { x: 0, y: 0 }
      }
    }
  }

  updateMovement(delta) {
    if (!this.isLeaping) {
      super.updateMovement(delta)
      return
    }

    this.isMoving = true
    this.moveByWithCollision(
      this.leapVelocity.x * delta,
      this.leapVelocity.y * delta
    )
  }
  
  updateAI(delta) {
    super.updateAI(delta)
    
    const player = this.game.player
    if (player && this.state === 'chase') {
      const dx = player.x - this.x
      const dy = player.y - this.y
      const dist = Math.sqrt(dx * dx + dy * dy)
      
      if (dist > 4 && dist < 10 && this.leapCooldown <= 0 && !this.isLeaping) {
        this.startLeap()
      }
    }
  }
  
  startLeap() {
    const player = this.game.player
    if (!player) return
    
    this.isLeaping = true
    this.leapCooldown = 8
    this.leapTimer = this.leapDuration
    
    const dx = player.x - this.x
    const dy = player.y - this.y
    const dist = Math.sqrt(dx * dx + dy * dy)
    
    this.leapVelocity = {
      x: (dx / dist) * this.leapSpeed,
      y: (dy / dist) * this.leapSpeed
    }
  }
  
  render(renderer) {
    super.render(renderer)
    
    // Draw leap trail
    if (this.isLeaping) {
      renderer.fillCircle(this.x, this.y, 0.4, 'rgba(100, 50, 150, 0.3)')
    }
  }
  
  dropLoot() {
    if (Math.random() < 0.3) {
      this.game.itemManager.spawnItem({
        type: 'item',
        id: 'wolf_pelt',
        name: 'Wolf Pelt',
        count: 1
      }, { x: this.x, y: this.y })
    }
  }
}
